import api from "./axiosConfig";

export interface OperatorTask {
  id: string;
  tenantId: string;
  clientId?: string | null;
  clientName: string;
  assignedToUserId?: string | null;
  assignedStaffName?: string | null;
  title: string;
  description: string;
  priority: string;
  status: string;
  dueDate?: string | null;
  completedAt?: string | null;
  createdAt: string;
}

export interface TaskListQuery {
  status?: string;
  priority?: string;
  assignedToUserId?: string;
  /** dueDate | priority | createdAt */
  sort?: string;
}

export interface CreateTaskPayload {
  clientId?: string | null;
  assignedToUserId?: string | null;
  title: string;
  description: string;
  priority: string;
  status: string;
  dueDate?: string | null;
}

export interface UpdateTaskPayload {
  clientId?: string | null;
  assignedToUserId?: string | null;
  title?: string;
  description?: string;
  priority?: string;
  status?: string;
  dueDate?: string | null;
  completedAt?: string | null;
}

export const tasksApi = {
  getAll: async (query?: TaskListQuery): Promise<OperatorTask[]> => {
    const { data } = await api.get<OperatorTask[]>("/tasks", { params: query });
    return data;
  },

  create: async (payload: CreateTaskPayload): Promise<OperatorTask> => {
    const { data } = await api.post<OperatorTask>("/tasks", payload);
    return data;
  },

  update: async (id: string, payload: UpdateTaskPayload): Promise<OperatorTask> => {
    const { data } = await api.put<OperatorTask>(`/tasks/${id}`, payload);
    return data;
  },

  updateStatus: async (id: string, status: string): Promise<OperatorTask> => {
    const { data } = await api.put<OperatorTask>(`/tasks/${id}/status`, { status });
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },
};
